'use strict';

import { queryFirst, queryAll, addClass, removeClass } from '../domUtil';
import {
    getJSON,
    geolocate,
    setItemInLocalStorage,
    getItemFromLocalStorage
} from '../util';
import { includeGoogleMaps, getLatLong } from '../googleMaps';
import { PREFERRED_STORE_ID } from '../constants';
import { updateCartTotals, updatePromoCodeDetails, updateApproachingDiscounts, updateShippingApproachingDiscounts, updateGwpIspuExclusionMessages, updateGWP, validateBasket } from '../cart/cart';
import { toggleLocationIcon } from './pickUpInStore/ispuHelper';

const $body = $('body');
const isSetPage = $('.custom-set-detail');
const hiddenClass = 'd-none';
let ispuContainer = queryFirst('.pickup-in-store-container');
let ispuModalContainer = $('.lp-slideout-modal[id*="pick-up-in-store"]');
const pickUpInStoreButton = queryFirst('.btn-in-store-pickup');
const isRecognizedUser = pickUpInStoreButton && pickUpInStoreButton.dataset.isRecognizedUser === 'true';
let ispuClosestParent = isSetPage.length > 0 ? $('.custom-set-detail-shop-by-item .product-detail') : $('.product-detail, .cart-page');

/**
 * This method checks if the user is on cart page
 * @returns {boolean} is cart page or not
 */
function isInCartPage() {
    const cartPage = queryFirst('.cart-page');
    return !!cartPage;
}

/**
 * This method checks if the user is on PDP page
 * @returns {boolean} is PDP page or not
 */
function isInPdpPage() {
    const pdpPage = queryFirst('.pdp-container');
    return !!pdpPage;
}

/**
 * This method returns ISPU cart line items details
 * @returns {Object} ISPU cart line items details
 */
function getIspuCartLineItemDetails() {
    const storePickupInfo = queryFirst('.cart-page .store-pickup-info');
    const ispuLineItems = queryAll('.cart-product-line-item', storePickupInfo);
    let ispuLineItemsData = [];
    if (ispuLineItems) {
        ispuLineItems.forEach(ispuLineItem => {
            const { pid, uuid } = ispuLineItem.dataset;
            const quantity = queryFirst('.quantity', ispuLineItem).value;
            ispuLineItemsData.push({
                pid,
                uuid,
                quantity
            });
        });
    }
    return ispuLineItemsData;
}

/**
 * This method handles the store results content
 * @param {Object} data store results
 */
function handleStoreResults(data) {
    const noStoresMessage = queryFirst('.store-locator-no-results', ispuContainer);
    const storeResults = queryFirst('.pick-up-in-stores', ispuContainer);
    const productDetails = queryFirst('.pickup-in-store-product', ispuContainer);
    addClass(queryFirst('.geo-location-error', ispuContainer), hiddenClass);
    if (data.storesResultsHtml) {
        storeResults.innerHTML = data.storesResultsHtml;
        noStoresMessage.textContent = '';
        if (!data.isCartPage) {
            removeClass(productDetails, hiddenClass);
        }
        removeClass(storeResults, hiddenClass);
        addClass(noStoresMessage, hiddenClass);

        if (isRecognizedUser && data.preferredStore) {
            setItemInLocalStorage(PREFERRED_STORE_ID, data.preferredStore.ID);
        }
    } else if (data.noStoresErrorMessage) {
        noStoresMessage.innerHTML = data.noStoresErrorMessage;
        if (!data.isCartPage) {
            addClass(productDetails, hiddenClass);
        }
        addClass(storeResults, hiddenClass);
        removeClass(noStoresMessage, hiddenClass);
    }
    ispuModalContainer.spinner().stop();
}

/**
 * This method handles the store confirmation results content
 * @param {Object} data store results
 */
function handleConfirmStoreResults(data) {
    const storeConfirm = queryFirst('.pick-up-confirm-section', ispuContainer);
    const storeResults = queryFirst('.pick-up-in-stores', ispuContainer);
    const storeForm = queryFirst('.find-stores-form', ispuContainer);
    storeConfirm.innerHTML = data.storesResultsHtml;
    if (data.storesResultsHtml) {
        removeClass(storeConfirm, hiddenClass);
        addClass([storeResults, storeForm], hiddenClass);
    }
    ispuModalContainer.spinner().stop();
}

/**
 * This method is an error handler of ajax call
 */
function errorCallBack() {
    ispuModalContainer.spinner().stop();
}

// Event listener to retrieve store results on click of Pick up in store in PDP
$('.pdp-in-store-inventory, .cart-page').on('click', '.btn-in-store-pickup', event => {
    const { currentTarget } = event;
    const { actionUrl, pid, googleKey, productName, swatchName, masterId } = currentTarget.dataset;
    const isCartPage = isInCartPage();
    const ispuContainerDataset = ispuContainer.dataset;
    const mixinData = {
        products: pid,
        isCartPage
    };
    includeGoogleMaps(googleKey);
    if (!isCartPage) {
        ispuModalContainer = $(currentTarget).closest('.product-detail').find('.lp-slideout-modal[id*="pick-up-in-store"]');
        ispuContainer = queryFirst('.lp-slideout-modal .pickup-in-store-container', currentTarget.closest('.product-detail'));
    }
    ispuContainerDataset.pid = pid;
    ispuContainerDataset.productName = productName;
    ispuContainerDataset.swatchName = swatchName;
    ispuContainerDataset.masterId = masterId;
    if (isRecognizedUser) {
        const storeId = getItemFromLocalStorage(PREFERRED_STORE_ID);

        if (storeId) {
            mixinData.storeID = storeId;
        }
    }
    if (ispuContainerDataset.selectStoreView === 'true') {
        mixinData.selectStoreView = true;
    }
    if (isCartPage) {
        const quantity = queryFirst('.quantity', currentTarget.closest('.cart-product-line-item')).value;
        mixinData.quantity = quantity;
        const { uuid } = currentTarget.dataset;
        ispuContainerDataset.uuid = uuid;
        ispuContainerDataset.quantity = quantity;
        addClass(queryFirst('.pickup-in-store-product'), hiddenClass);
    } else {
        ispuContainerDataset.quantity = 1;
    }
    geolocate(data => {
        ispuModalContainer.spinner().start();
        toggleLocationIcon(true, ispuContainer);
        getJSON(actionUrl, 'GET', data, handleStoreResults, errorCallBack);
    }, mixinData, data => {
        toggleLocationIcon(false, ispuContainer);
        getJSON(actionUrl, 'GET', data, handleStoreResults, errorCallBack);
    });
});

// Event listener to select a store from ISPU drawer
ispuClosestParent.on('click', '.btn-select-store', event => {
    const { target } = event;
    const { storeId } = target.dataset;
    const productContainer = target.closest('.product-detail');

    $body.trigger('product:updateStoreInventory', { storeId, productContainer });

    $(target)
        .closest('.lp-slideout-modal')
        .modal('hide');
});

// Event Listener for edit pick up store link in cart page
$('.cart-page').on('click', '.btn-edit-store-pickup', event => {
    ispuContainer.dataset.editStore = 'true';
    const products = null;
    const { actionUrl, googleKey } = event.currentTarget.dataset;
    includeGoogleMaps(googleKey);
    addClass(queryFirst('.pickup-in-store-product'), hiddenClass);
    const mixinData = {
        products,
        isCartPage: true
    };
    geolocate(data => {
        ispuModalContainer.spinner().start();
        toggleLocationIcon(true, ispuContainer);
        getJSON(actionUrl, 'GET', data, handleStoreResults, errorCallBack);
    }, mixinData, data => {
        toggleLocationIcon(false, ispuContainer);
        getJSON(actionUrl, 'GET', data, handleStoreResults, errorCallBack);
    });
});

/**
 * This method retrieves store results based on zipcode, city or state
 * @param {Object} locationData google location data based on input value
 */
function handleInStore(locationData) {
    const { latitude, longitude, address, actionUrl, forceGeoLocation } = locationData;
    const ispuContainerDataset = ispuContainer.dataset;
    const isEditStore = JSON.parse(ispuContainerDataset.editStore || 'false');
    let products = null;
    if (!isEditStore) {
        products = ispuContainerDataset.pid + ':' + ispuContainerDataset.quantity;
    }
    const isCartPage = isInCartPage();
    const data = {
        products,
        latitude,
        longitude,
        inputSearchParameter: address,
        isCartPage,
        forceGeoLocation
    };
    if (ispuContainerDataset.selectStoreView === 'true') {
        data.selectStoreView = true;
    }
    if (isRecognizedUser) {
        const storeId = getItemFromLocalStorage(PREFERRED_STORE_ID);
        if (storeId) {
            data.storeID = storeId;
        }
    }
    ispuModalContainer.spinner().start();
    getJSON(actionUrl, 'GET', data, handleStoreResults, errorCallBack);
}

// Event listener to retrieve store results based on input search in pick up in store drawer
ispuClosestParent.on('submit', '.find-stores-form', event => {
    event.preventDefault();
    const { target } = event;
    const actionUrl = target.getAttribute('action');
    const address = queryFirst('.find-store-input', target.closest('.find-stores-form')).value;
    if (address) {
        getLatLong(handleInStore, {
            address,
            actionUrl
        });
    }
});

/**
 * This method retrieves store results based on zipcode, city or state after preferred store slection
 * @param {Object} locationData google location data based on input value
 */
function handlePreferredStore(locationData) {
    const url = queryFirst('.preferred-store-input').dataset.actionUrl;
    const isCartPage = isInCartPage();
    const { latitude, longitude, address, storeID, products } = locationData;
    const data = {
        products,
        latitude,
        longitude,
        inputSearchParameter: address,
        storeID,
        isCartPage,
        selectStoreView: isInPdpPage()
    };
    ispuModalContainer.spinner().start();
    getJSON(url, 'POST', data, handleStoreResults, errorCallBack);
}

// Event listener to update preferred store and rerender store results
ispuClosestParent.on('click', '.preferred-store-input', event => {
    const { target } = event;
    const isEditStore = JSON.parse(ispuContainer.dataset.editStore);
    let products = null;
    if (!isEditStore) {
        products = ispuContainer.dataset.pid;
    }
    const address = queryFirst('.find-store-input').value;
    const { dataset } = target;
    const { actionUrl, storeId } = dataset;
    const isCartPage = isInCartPage();
    const mixinData = {
        products,
        storeID: storeId,
        isCartPage
    };
    if (isCartPage && !isEditStore) {
        mixinData.quantity = ispuContainer.dataset.quantity;
    }
    if (address) {
        mixinData.address = address;
        getLatLong(handlePreferredStore, mixinData);
    } else {
        const isCartPage = isInCartPage();
        geolocate(
            data => {
                ispuModalContainer.spinner().start();
                getJSON(actionUrl, 'POST', data, handleStoreResults);
            },
            {
                products,
                storeID: storeId,
                isCartPage,
                selectStoreView: isInPdpPage()
            },
            data => {
                getJSON(actionUrl, 'POST', data, handleStoreResults);
            }
        );
    }
});

// Event listener to render pick up in store confirmation template
ispuClosestParent.on('click', '.pick-up-confirm-button', event => {
    const { dataset } = event.target;
    const { actionUrl, storeId } = dataset;
    const isCartPage = isInCartPage();
    const data = {
        storeID: storeId,
        isCartPage
    };
    ispuModalContainer.spinner().start();
    getJSON(actionUrl, 'GET', data, handleConfirmStoreResults, errorCallBack);
});

// Event listener to ISPU store confirmation in cart
ispuClosestParent.on('click', '.store-confirm-button', event => {
    const { target } = event;
    const { actionUrl } = target.dataset;
    const storeID = target.closest('.store-details').dataset.storeId;
    const isEditStore = JSON.parse(ispuContainer.dataset.editStore);
    let data;
    if (isEditStore) {
        const productsInfo = JSON.stringify(getIspuCartLineItemDetails());
        data = {
            productsInfo,
            storeID
        };
    } else {
        const { pid, uuid, quantity } = ispuContainer.dataset;
        data = {
            pid,
            uuid,
            quantity,
            storeID
        };
    }
    ispuModalContainer.spinner().start();
    getJSON(
        actionUrl,
        'POST',
        data,
        data => {
            if (data.error) {
                const { lineItemErrorMessage } = data;
                ispuModalContainer.spinner().stop();
                ispuModalContainer.modal('hide');
                $('.add-to-cart-messages').remove();
                if ($('.add-to-cart-messages').length === 0) {
                    $('body').append('<div class="add-to-cart-messages"></div>');
                }
                $('.add-to-cart-messages').append('<div class="alert alert-danger add-to-basket-alert text-center" role="alert">' + lineItemErrorMessage + '</div>');
                setTimeout(function () {
                    $('.add-to-basket-alert').remove();
                }, 5000);
            } else {
                const { cartProductsHtml, totals } = data;
                const { discountsHtml } = totals;
                const couponsEl = queryFirst('.coupons-and-promos');

                if (couponsEl && discountsHtml) {
                    couponsEl.innerHTML = discountsHtml;
                }
                if (cartProductsHtml) {
                    queryFirst('.cart-products').innerHTML = cartProductsHtml;
                    removeClass(queryFirst('.cart-pickup-products'), hiddenClass);
                    updatePromoCodeDetails(data.totals.discounts, data.selectedShippingMethod);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts, data.approachingDiscountsLabels);
                    updateShippingApproachingDiscounts(data.approachingShippingDiscounts);
                    updateGwpIspuExclusionMessages(data.gwpIspuExclusionMessages);
                    updateGWP(data);
                    validateBasket(data);
                    $('body').trigger('cart:update');
                    ispuModalContainer.spinner().stop();
                    ispuModalContainer.modal('hide');
                }
            }
        },
        () => {
            ispuModalContainer.spinner().stop();
        }
    );
});

// Event listener to toggle store details accordion label
ispuClosestParent.on('click', '.store-locator-container .store-btn-link', event => {
    const { target } = event;
    queryFirst('.collapsed', target).classList.toggle(hiddenClass);
    queryFirst('.expanded', target).classList.toggle(hiddenClass);
});

// Event listener to show stores to select on click of change location on pickup confirmation page
ispuClosestParent.on('click', '.change-location-link', () => {
    addClass(queryFirst('.pick-up-confirm-section'), hiddenClass);
    removeClass(queryAll('.pick-up-in-stores, .find-stores-form'), hiddenClass);
});

// Event listener to remove no stores error message on change of ISPU search input
ispuClosestParent.on('keyup', '.find-store-input', (event) => {
    queryFirst('.store-locator-no-results', ispuModalContainer[0]).textContent = '';
    queryFirst('.pick-up-in-stores', ispuContainer).innerHTML = '';
    addClass(queryFirst('.geo-location-error', ispuContainer), hiddenClass);
    const findStoreSubmit = queryFirst('.find-store-submit', ispuContainer);
    if (event.target.value) {
        findStoreSubmit.removeAttribute('disabled');
    } else {
        findStoreSubmit.disabled = true;
    }
});

$('.lp-slideout-modal[id*="pick-up-in-store"]').on('hidden.bs.modal', () => {
    queryFirst('.find-store-input', ispuContainer).value = '';
    removeClass(queryAll('.pickup-in-store-product, .find-stores-form', ispuContainer), hiddenClass);
    queryFirst('.pick-up-in-stores', ispuContainer).innerHTML = '';
    const noStoresMessage = queryFirst('.store-locator-no-results', ispuContainer);
    const confirmSection = queryFirst('.pick-up-confirm-section', ispuContainer);
    const geolocateError = queryFirst('.geo-location-error', ispuContainer);
    confirmSection.innerHTML = '';
    addClass([confirmSection, noStoresMessage, geolocateError], hiddenClass);
    queryFirst('.find-store-submit', ispuContainer).disabled = true;
    if (isInCartPage()) {
        ispuContainer.dataset.editStore = 'false';
    }
});

// Event listener to retrieve geo location based store results on click of use current location
ispuClosestParent.on('click', '.detect-location', event => {
    const { target } = event;
    const { actionUrl } = target.dataset;
    const mixinData = { actionUrl, forceGeoLocation: true };
    const noStoresMessage = queryFirst('.store-locator-no-results', ispuContainer);
    const storeResults = queryFirst('.pick-up-in-stores', ispuContainer);
    queryFirst('.find-store-input', ispuContainer).value = '';
    queryFirst('.find-store-submit', ispuContainer).disabled = true;
    geolocate(handleInStore, mixinData, () => {
        removeClass(queryFirst('.geo-location-error', ispuContainer), hiddenClass);
        addClass([storeResults, noStoresMessage], hiddenClass);
    });
});
